<template>
  <div class="row m-0">
    <div class="col m-0">
      <div class="row m-0">
        <h1 class="display-3 font-weight-bold m-0 blueheader">Offer in compromise </h1>
      </div>
      <div class="row m-0">
        <h2 class="blueheaderh2 font-weight-bold">Step 1/5</h2>
      </div>
      <div class="row">
        <div class="col-8"></div>
        <div class="d-block col-4 mt-0 mb-2">
          <div class="text-right">
            <h3>Estimated time to complete: <span class="text-danger">10 min</span></h3>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col align-baseline">
          <h4 class="font-weight-bold">Basic Info</h4>
          <img class="mx-auto d-block img-fluid" src="@/assets/Circle64pxFill.png">
        </div>
        <div class="col">
          <img class="img-fluid" src="@/assets/CircleBar.png">
        </div>
        <div class="col align-baseline">
          <h4 class="font-weight-bold">Assets</h4>
          <img class="mx-auto d-block img-fluid" src="@/assets/Circle64px.png">
        </div>
        <div class="col">
          <div class=""><img class="img-fluid" src="@/assets/CircleBar.png"></div>
        </div>
        <div class="col align-baseline">
          <h4 class="font-weight-bold">Income and Expenses</h4>
          <img class="mx-auto d-block img-fluid" src="@/assets/Circle64px.png">
        </div>
        <div class="col">
          <div class=""><img class="img-fluid" src="@/assets/CircleBar.png"></div>
        </div>
        <div class="col align-baseline">
          <h4 class="font-weight-bold">Settlement Options</h4>
          <img class="mx-auto d-block img-fluid" src="@/assets/Circle64px.png">
        </div>
        <div class="col">
          <div class=""><img class="img-fluid" src="@/assets/CircleBar.png"></div>
        </div>
        <div class="col align-baseline">
          <h4 class="font-weight-bold">Summary and Submit</h4>
          <img class="mx-auto d-block img-fluid" src="@/assets/Circle64px.png">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "Progress"
    }
</script>

<style scoped>
  h1.blueheader {
    color: #2896C5;
  }
  h2.blueheaderh2 {
    color: #2896C5;
    font-size: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/oic/Progress.vue